import React from "react";
import ProviderValues from "./ProviderValues";
import { Row, Col } from "rsuite";
import LabelWithInfoIcon from "./LabelWithInfoIcon";

const ProviderValuesRow = ({
    sortedLicenses,
    label,
    infoText,
    valueGetter,
    xsRowValueWidth,
    mdRowValueWidth,
    bold = false,
    rowClass = "",
    labelClass = "",
    offsetRightStyle = { marginRight: '19px' }
}) => (
    <div role="grid">
        <Row className={rowClass} style={offsetRightStyle}> 
            <Col xs={12} md={16}>
                <LabelWithInfoIcon className={labelClass} isBold={bold} label={label} infoText={infoText} />
            </Col>
            <ProviderValues
                sortedLicenses={sortedLicenses}
                keyPrefix="taxable_receipts"
                valueGetter={valueGetter}
                bold={bold}
                mdRowValueWidth={mdRowValueWidth}
                xsRowValueWidth={xsRowValueWidth}
            />
        </Row>
    </div>
);

export default ProviderValuesRow;